/**
 * Motor Commercial Institutional PLL (per passenger).
 * Schools: KES 250 | Other institutions: KES 500.
 * Product code stays 0813 — only the PLL fee differs.
 */

export const INSTITUTIONAL_PLL_FEE_SCHOOL = 250;
export const INSTITUTIONAL_PLL_FEE_OTHER = 500;

export const INSTITUTION_TYPE_SCHOOL = 'school';
export const INSTITUTION_TYPE_OTHER = 'other';

/** @param {unknown} value */
export function normalizeInstitutionType(value) {
  const raw = String(value || '').trim().toLowerCase();
  if (raw === INSTITUTION_TYPE_OTHER || raw === 'other_institution' || raw === 'other institutions') {
    return INSTITUTION_TYPE_OTHER;
  }
  if (raw === INSTITUTION_TYPE_SCHOOL || raw === 'schools') {
    return INSTITUTION_TYPE_SCHOOL;
  }
  return null;
}

/**
 * @param {unknown} institutionType
 * @returns {number} PLL fee per passenger (defaults to school 250 when unset)
 */
export function getInstitutionalPllFee(institutionType) {
  const t = normalizeInstitutionType(institutionType);
  return t === INSTITUTION_TYPE_OTHER ? INSTITUTIONAL_PLL_FEE_OTHER : INSTITUTIONAL_PLL_FEE_SCHOOL;
}

export function institutionalPllLabel(institutionType) {
  return normalizeInstitutionType(institutionType) === INSTITUTION_TYPE_OTHER
    ? 'Other institutions'
    : 'Schools';
}
